import { createSlice } from "@reduxjs/toolkit";
import { updateEmailTemplateAPI } from "../../services/updateEmailTemplate";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const updateEmailTemplateSlice = createSlice({
  name: "updateEmailTemplate",
  initialState: data,
  reducers: {
    updateEmailTemplateInfo(state) {
      state.isLoading = true;
    },
    updateEmailTemplateSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    updateEmailTemplateFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    updateEmailTemplateReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const updateEmailTemplateHandler =
  (data, options = {}) =>
  async (dispatch) => {
  try {
    dispatch(updateEmailTemplateAction.updateEmailTemplateInfo());
    const response = await updateEmailTemplateAPI(data, options);
    dispatch(updateEmailTemplateAction.updateEmailTemplateSuccess(response));
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(updateEmailTemplateAction.updateEmailTemplateFailure(failurePayload));
  }
};
export default updateEmailTemplateSlice.reducer;
export const updateEmailTemplateAction = updateEmailTemplateSlice.actions;
